<script setup lang="ts">
import { useTranslation } from 'i18next-vue';
import { UiDialog, WarningWavyIcon } from '@peanuds/ui';

const visible = defineModel<boolean>('visible', { default: false });

const emit = defineEmits<{
  confirm: [];
  cancel: [];
}>();

const { t } = useTranslation();

const handleCancel = () => {
  emit('cancel');
};

const handleConfirm = () => {
  emit('confirm');
};
</script>

<template>
  <UiDialog
    v-model:visible="visible"
    :title="t('transactionDetails.cancelDialog.title')"
    :cancel-label="t('transactionDetails.cancelDialog.cancel')"
    :confirm-label="t('transactionDetails.cancelDialog.confirm')"
    confirm-severity="danger"
    :message="t('transactionDetails.cancelDialog.message')"
    :message-icon="WarningWavyIcon"
    data-testid="transaction-cancel-payment-dialog"
    @confirm="handleConfirm"
    @cancel="handleCancel"
  />
</template>
